import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { isEmpty } from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { finalize, switchMap, take, takeUntil } from 'rxjs/operators';
import { ContactSelfServiceFormsService } from '../contact-self-service-forms.service';
import { IGeneralScreenSettings } from '../landing-screen/landing-screen.component';

export interface IEmailVerificationScreenSettings
  extends IGeneralScreenSettings {
  emailVerificationContent?: string;
}

@Component({
  selector: 'app-email-verification-screen',
  templateUrl: './email-verification-screen.component.html',
  styleUrls: ['./email-verification-screen.component.scss'],
})
export class EmailVerificationScreenComponent implements OnInit, OnDestroy {
  settings: IEmailVerificationScreenSettings;
  contactType: string;
  email: string;
  loaded: Boolean = false;
  browserLang: string;
  private destroy$: Subject<void> = new Subject();
  constructor(
    private contactSelfServiceFormsService: ContactSelfServiceFormsService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private sanitizer: DomSanitizer,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    this.browserLang = this.contactSelfServiceFormsService.getBrowserLang();
    this.loadSchema();
    this.getEmail()
      .pipe(takeUntil(this.destroy$))
      .subscribe((email) => (this.email = email));
  }

  getEmail(): BehaviorSubject<string> {
    return this.contactSelfServiceFormsService.enteredEmail$;
  }

  loadSchema(): void {
    this.titleService.setTitle('Contact self-service');
    this.activatedRoute.paramMap
      .pipe(
        switchMap((params) => {
          this.contactType = params.get('type');
          return this.contactSelfServiceFormsService.fetchSchema<IEmailVerificationScreenSettings>(
            'emailVerification',
            this.contactType,
            this.browserLang
          );
        }),
        take(1),
        finalize(() => (this.loaded = true))
      )
      .subscribe(
        (schema: IEmailVerificationScreenSettings) => {
          this.settings = !isEmpty(schema) ? schema : {};
          if (this.settings.logo) {
            this.settings.logoBase64 = 'data:image/svg+xml;base64,' + this.settings.logo;
          }
        },
        (err) => {
          this.snackBar.open('Unable to load form.');
        }
      );
  }

  tryAgain(): void {
    this.router.navigate(['./contact-form', 'landing', this.contactType]);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
